export default {
  SET_ERRORS: (state, errors) => (state.errors = errors),
  SET_SUCCESS: (state, success) => (state.success = success),
  SET_EMPLOYEES: (state, employees) => (state.employees = employees),
  SET_SEARCH_KEYWORD: (state, search_keyword) =>
    (state.search_keyword = search_keyword),
  SET_SEARCH_STATION: (state, search_station) =>
    (state.search_station = search_station),
  SET_NEXT_EMPLOYEES_URL: (state, next_employees_url) =>
    (state.next_employees_url = next_employees_url),
  SET_SHOULD_APPEND: (state, shouldAppend) =>
    (state.shouldAppend = shouldAppend),
};
